//@ts-check
import * as THREE from "three";
import viewerMgrInstance from '../ViewerMgr.js';

/**
 * @module Visibility
 */



/**
 * Shows and Hide model elements
 * @param {boolean} status - status if false hide if true show
 * @param {boolean} [render = false] 
 * @returns {Object} Return success or error messages 
 * { status:  mesage: }
 */
export function showAll(status, render = false) {
  var scope = this;
  try {
    if (scope.modelScene.children.length != 0) {

      scope.elementsMap.forEach((element, name) => {
        if (element instanceof THREE.Mesh) {
          if (status && !element.visible) {
            element.visible = status;
            scope.lockElement(name, !status);

            let elem = scope.edgesMap.get(name);
            if (elem) elem.visible = status;
          }

        }
      })

      if (render) {
        viewerMgrInstance.render();
      }
      var returnValue = {
        "status": "success",
        "message": "Show all API"
      }
      return returnValue;
    }
    else {
      var returnValue = {
        "status": "failed",
        "message": "ERROR : Model is not loaded in viewer."
      }
      return returnValue;
    }
  }
  catch (err) {
    var returnValue = {
      "status": "failed",
      "message": "System Error" + err.message
    }
    return returnValue;
  }
}


/**
 * Show Element
 * @param {string} element_ID - Element Id
 * @param {boolean} status - status
 * @param {boolean} [render= false] - render 
 * @returns {Object} Return success or error messages 
 * { status:  mesage: }
 */
export function showElement(element_ID, status, render = false) {
  var scope = this;
  try {
    if (scope.modelScene.children.length != 0) {
      let child = scope.elementsMap.get(element_ID);

      scope.lockElement(element_ID, !status);
      child.visible = status;

      let elem = scope.edgesMap.get(element_ID);
      elem.visible = status;

      scope.recalculateShadows();
      if (render) {
        viewerMgrInstance.render();
      }
      var returnValue = {
        "status": "success",
        "message": "Show element API"
      }
      return returnValue;
    }
    else {
      var returnValue = {
        "status": "failed",
        "message": "ERROR : Load the model in viewer."
      }
      return returnValue;
    }
  }
  catch (err) {
    var returnValue = {
      "status": "failed",
      "message": "System Error: " + err.message
    }
    return returnValue;
  }
}

/**
 * Shows or hides multiple elements
 * @param {Array<string>} element_Ids - Element Ids
 * @param {boolean} status - status if true show, if false hide
 * @returns {Object} Return success or error messages 
 * { status:  mesage: }
 */
export function showElements(element_Ids, status) {

  var scope = this;
  try {
    if (scope.modelScene.children.length != 0 && element_Ids.length >= 1) {

      for (let i = 0; i < element_Ids.length; i++) {
        scope.showElement(element_Ids[i], status);
      }
      var returnValue = {
        "status": "success",
        "message": "Show elements API"
      }
      return returnValue;
    }
    else {
      var returnValue = {
        "status": "failed",
        "message": "ERROR : Model is not loaded in viewer."
      }
      return returnValue;
    }
  }
  catch (err) {
    var returnValue = {
      "status": "failed",
      "message": "System Error: " + err.message
    }
    return returnValue;
  }
}

/**
 * Isolate Element 
 * @param {string} element_ID - element Id
 * @returns {Object} Return success or error messages 
 * { status:  mesage: }
 */
export function isolateElement(element_ID) {
  var scope = this;
  try {
    if (scope.modelScene.children.length != 0) {
      scope.showAll(false); // hide all then 
      let child = scope.elementsMap.get(element_ID);

      if (child instanceof THREE.Mesh) {
        scope.showElement(element_ID, true);
      }

      var returnValue = {
        "status": "success",
        "message": "Isolate element API"
      }
      return returnValue;
    }
    else {
      var returnValue = {
        "status": "failed",
        "message": "ERROR : Load the model in viewer."
      }
      return returnValue;
    }
  }
  catch (err) {
    var returnValue = {
      "status": "failed",
      "message":"System Error: " + err.message
    }
    return returnValue;
  }
}

/**
 * Isolates multiple elements
 * @param {Array<string>} element_Ids - Element Ids
 * @returns {Object} Return success or error messages 
 * { status:  mesage: }
 */
export function isolateElements(element_Ids) {
  var scope = this;
  try {
    if (scope.modelScene.children.length != 0 && element_Ids.length >= 1) {

      let elementIdsSet = new Set(element_Ids);
      scope.elementsMap.forEach((element, name) => {

        if (!elementIdsSet.has(name)) {
          scope.showElement(name, false);
        }
        else {
          scope.showElement(name, true);
        }
      })

      var returnValue = {
        "status": "success",
        "message": "Isolate elements API"
      }
      return returnValue;
    }
    else {
      var returnValue = {
        "status": "failed",
        "message": "ERROR : Model is not loaded in viewer."
      }
      return returnValue;
    }
  }
  catch (err) {
    var returnValue = {
      "status": "failed",
      "message": "System Error:" + err.message
    }
    return returnValue;
  }
}

/**
 * Is Object Visible
 * @param {THREE.Object3D} element 
 * @returns {boolean} Returns whether is object visible or not
 */
export function isObjectVisible(element) {
  var scope = this;
  var box = new THREE.Box3();
  box.setFromObject(element);
  var center = box.getCenter(new THREE.Vector3());

  const vector = center.project(scope.camera)

  scope.raycaster.setFromCamera(vector, scope.camera)
  const intersects = scope.raycaster.intersectObjects(scope.modelScene, false)

  if (intersects.length) {
    const intersectionDistance = intersects[0].distance
    const pointDistance = element.position.distanceTo(scope.raycaster.ray.origin)
    return pointDistance < intersectionDistance
  }
  return true
}


/**
 * Locks Single element
 * @param {string} element_ID - Element ID
 * @param {boolean} status - Status if true lock if false not lock
 * @param {boolean} [render = false] - render ?
 * @returns {Object} Return success or error messages 
 * { status:  mesage: } 
 */
export function lockElement(element_ID, status, render = false) {
  var scope = this;
  try {
    if (scope.modelScene.children.length != 0) {
      let child = scope.elementsMap.get(element_ID);

      if (child instanceof THREE.Mesh) {
        if (status) {
          child.layers.disable(1);
          child.layers.enable(2);
        } else {
          child.layers.disable(2);
          child.layers.enable(1);
        }
      }

      if (render) {
        viewerMgrInstance.render();
      }
      var returnValue = {
        "status": "success",
        "message": "Lock element API"
      }
      return returnValue;
    }
    else {
      var returnValue = {
        "status": "failed",
        "message": "ERROR : Load the model in viewer."
      }
      return returnValue;
    }
  }
  catch (err) {
    var returnValue = {
      "status": "failed",
      "message": "System Error :" + err.message
    }
    return returnValue;
  }
}

/**
 * Locks multiple elements
 * @param {Array<string>} element_Ids - Element ids
 * @param {boolean} status - Status if true lock elements, if false unlock
 * @returns {Object} Return success or error messages 
 * { status:  mesage: }
 */
export function lockElements(element_Ids, status) {
  var scope = this;
  try {

    if (scope.modelScene.children.length != 0 && element_Ids.length >= 1) {

      for (let i = 0; i < element_Ids.length; i++) {
        scope.lockElement(element_Ids[i], status);
      }
      viewerMgrInstance.render();
      var returnValue = {
        "status": "success",
        "message": "Lock elements API"
      }
      return returnValue;
    }
    else {
      var returnValue = {
        "status": "failed",
        "message": "ERROR : Load the model in viewer."
      }
      return returnValue;
    }
  }
  catch (err) {
    var returnValue = {
      "status": "failed",
      "message": "System Error :" + err.message
    }
    return returnValue;
  }
}

// set single element opacity
export function setElementOpacity(element_ID, opacity, render = false) {
  var scope = this;
  try {
    if (scope.modelScene.children.length != 0 && 0.0 <= opacity <= 1.0) {
      let child = scope.elementsMap.get(element_ID);
      if (child instanceof THREE.Mesh) {
        // capture original once
        if (!child.userData.originalMaterial) {
          child.userData.originalMaterial = child.material;
        }
        scope.opacityTempMaterial = child.material.clone();
        scope.opacityTempMaterial.transparent = true;
        scope.opacityTempMaterial.opacity = opacity;
        scope.opacityTempMaterial.forceSinglePass = true;
        child.material = scope.opacityTempMaterial;
        child.userData.opacity = opacity;
      }
      if (render) {
        viewerMgrInstance.render();
      }
      var returnValue = {
        "status": "success",
        "message": "Element Opacity API"
      }
      return returnValue;
    }
    else {
      var returnValue = {
        "status": "failed",
        "message": "ERROR : Either model is not loaded in viewer or opacity is not between 0.0 to 1.0."
      }
      return returnValue;
    }
  }
  catch (err) {
    var returnValue = {
      "status": "failed",
      "message": err.message
    }
    return returnValue;
  }
}

// set multiple element's opacity
export function setOpacity(element_Ids, opacity) {
  var scope = this;
  try {

    if (scope.modelScene.children.length != 0 && element_Ids.length >= 1) {
      for (let i = 0; i < element_Ids.length; i++) {
        scope.setElementOpacity(element_Ids[i], opacity);
      }
      //viewerMgrInstance.render();
      var returnValue = {
        "status": "success",
        "message": "Set opacity API"
      }
      return returnValue;
    }
    else {
      var returnValue = {
        "status": "failed",
        "message": "ERROR : Either model is not loaded in viewer or element id is zero."
      }
      return returnValue;
    }
  }
  catch (err) {
    var returnValue = {
      "status": "failed",
      "message": err.message
    }
    return returnValue;
  }
}

// Set element opacity by adjusting existing material
export function fadeElement(element_ID, opacity, render = false) {
  const scope = this;
  try {
    const child = scope.elementsMap.get(element_ID);
    if (child instanceof THREE.Mesh) {
      // Store original material once if not already stored
      if (!child.userData.originalMaterial) {
        child.userData.originalMaterial = child.material;
      }

      // Create a clone of the current material to preserve color
      // but don't recreate it if we already have a faded version
      if (!child.userData.fadedMaterial) {
        // Clone current material (whether it's colorBy or original)
        child.userData.fadedMaterial = child.material.clone();
      }
      
      // Apply transparency
      child.material = child.userData.fadedMaterial;
      child.material.transparent = opacity < 1.0;
      child.material.opacity = opacity;
      child.userData.opacity = opacity;
      child.userData.filtered = true; // Mark as filtered
    }
    if (render) viewerMgrInstance.render();
    return { status: 'success', message: 'Element Fade API' };
  } catch (err) {
    return { status: 'failed', message: err.message };
  }
}

// Apply fade effect to multiple elements
export function fadeElements(element_Ids, opacity) {
  const scope = this;
  try {
    element_Ids.forEach(id => scope.fadeElement(id, opacity));
    viewerMgrInstance.render();
    return { status: 'success', message: 'Set fade opacity API' };
  } catch (err) {
    return { status: 'failed', message: err.message };
  }
}

// Temporarily apply ghost (grey) material by reusing global ghostMaterial
export function ghostElement(element_ID, render = false) {
  const scope = this;
  try {
    const child = scope.elementsMap.get(element_ID);
    // Store original material once
    child.userData.originalMaterial = child.userData.originalMaterial || child.material;
    // Apply global ghostMaterial
    child.material = scope.ghostMaterial;
    // Mark as ghosted to allow resetElement to restore
    child.userData.ghosted = true;
    if (render) viewerMgrInstance.render();
    return { status: 'success', message: 'Element Ghost API' };
  } catch (err) {
    return { status: 'failed', message: err.message };
  }
}

// Apply ghost effect to multiple elements
export function ghostElements(element_Ids) {
  const scope = this;
  try {
    element_Ids.forEach(id => scope.ghostElement(id));
    viewerMgrInstance.render();
    return { status: 'success', message: 'Set ghost API' };
  } catch (err) {
    return { status: 'failed', message: err.message };
  }
}

// Restore original material for one element
export function restoreMaterial(element_ID, render = false) {
  const scope = this;
  try {
    const child = scope.elementsMap.get(element_ID);
    if (child instanceof THREE.Mesh) {
      // Restore colorBy material if it exists, otherwise original
      if (child.userData.colorMaterial) {
        child.material = child.userData.colorMaterial;
      } else if (child.userData.originalMaterial) {
        child.material = child.userData.originalMaterial;
      }
      
      // Clean up filter effect flags and materials
      delete child.userData.ghosted;
      delete child.userData.opacity;
      delete child.userData.filtered;
      delete child.userData.fadedMaterial;
    }
    if (render) viewerMgrInstance.render();
    return { status: 'success', message: 'Restore material API' };
  } catch (err) {
    return { status: 'failed', message: err.message };
  }
}

// Restore original material for multiple elements
export function restoreElements(element_Ids) {
  const scope = this;
  try {
    element_Ids.forEach(id => scope.restoreMaterial(id));
    viewerMgrInstance.render();
    return { status: 'success', message: 'Restore elements API' };
  } catch (err) {
    return { status: 'failed', message: err.message };
  }
}
